"use client";
import { createContext, useContext } from "react";
import type { NavBranch } from "@/components/nav-secondary";
const ReferenceTree = createContext<NavBranch[]>([]);
export const useReferenceTree = () => useContext(ReferenceTree);
export function ReferenceTreeProvider({
  tree,
  children,
}: {
  tree: NavBranch[];
  children: React.ReactNode;
}) {
  return (
    <ReferenceTree.Provider value={tree}>{children}</ReferenceTree.Provider>
  );
}
